/* eslint-disable */
import camelCase from './camelcase'

export default function (args) {
  const cased = camelCase(args);
  return cased.charAt(0).toUpperCase() + cased.slice(1);
};
